import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createContext, ReactNode, useContext } from 'react';

import { apiGetMe, Me } from '@/shared/api';

export type AuthContextType = {
  isInitiated: boolean;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  logout: () => void;
  isGuest: boolean;
  me: Me | undefined;
};

const AuthContext = createContext<AuthContextType>({
  isInitiated: false,
  isError: false,
  isPending: false,
  isSuccess: false,
  logout: () => {},
  isGuest: true,
  me: undefined,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const queryClient = useQueryClient();

  // const [isInitiated, setIsInitiated] = useState(false);
  // const [isError, setIsError] = useState(false);
  // const [isPending, setIsPending] = useState(false);
  // const [isSuccess, setIsSuccess] = useState(false);

  const query = useQuery({
    queryFn: apiGetMe,
    queryKey: ['apiGetMe'],
    throwOnError: false,
    retry: (failureCount, error) => {
      if (error instanceof AxiosError && error.response?.status === 401) {
        return false;
      }

      return failureCount < 3; // Retry up to 3 times for other errors
    },
  });

  return (
    <AuthContext.Provider
      value={{
        isInitiated: true,
        isError: query.isError,
        isPending: query.isPending,
        isSuccess: query.isSuccess,
        logout: () => {
          localStorage.removeItem('token');
          queryClient.resetQueries();
        },
        isGuest: !query.isSuccess,
        me: query.data?.data,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
